import type { MouseEventHandler, ReactElement, ReactNode } from 'react';

import { StyledNativeLinkWithRef } from './StyledNativeLinkWithRef';

type Props = {
  link?: string | null | undefined;
  children?: ReactNode;
  className?: string;
  onClick?: MouseEventHandler;
  qaId?: string;
};

export function ConditionalStyledLinkWithRef({
  link,
  children,
  className,
  onClick,
  qaId,
}: Props): ReactElement {
  // oxlint-disable-next-line react/jsx-no-useless-fragment
  if (!link) return <>{children}</>;

  return (
    <StyledNativeLinkWithRef
      qaId={qaId}
      href={link}
      className={className}
      onClick={onClick}
    >
      {children}
    </StyledNativeLinkWithRef>
  );
}
